$ = require('jquery')
require("bootstrap-daterangepicker")
moment = require("moment")

GroupEventRegistCtrl = ($scope ,$filter ,$location ,flash ,formDialogService ,formFileReaderService ,groupInfo ,groupRegisDataService ,groupEventService ,$ngConfirm ) ->
  # check invalid groupInfo
  if groupInfo is undefined || groupInfo.id is undefined
    return $location.path('/groups')

  angular.element(document.body).css 'min-width', 0
  $scope.eventInfo =
    group_id : groupInfo.id
    start_date : moment().format("'YYYY-MM-DD'T'HH:mm:ssZ'")
    end_date : moment().format("'YYYY-MM-DD'T'HH:mm:ssZ'")

  defDirS3 =
    prefixCover: 'images/group/event'
  maxFileUploadSize = 5000000
  configDatePicker =
    singleDatePicker: true
    showDropdowns: true
    locale:
      format: "YYYY/MM/DD"

  $scope.isSubmitting = false
  $scope.coverPhoto = ''
  $scope.croppedCoverPhoto = ''
  $scope.croppedCoverPhotoBlob = ''

  # cover url
  groupRegisDataService.createS3ImageURL(defDirS3.prefixCover).then (resp) ->
    $scope.preDataCover = resp.data

  $(document).ready () ->
    document.body.scrollTop = document.documentElement.scrollTop = 0
    $('#txtStartDate').daterangepicker configDatePicker , (start, end) ->
      checkValidDate()
    $('#txtEndDate').daterangepicker configDatePicker , (start, end) ->
      checkValidDate()

  $scope.chooseCover = ->
    openFileDialog( (file, fileLocation) ->
      formFileReaderService.loadImageOrientation('coverPhoto', file).then (data) ->
        $scope.coverData = data
        $scope.coverPhoto = data.base64Data
        $('.crop-image-modal').modal 'show'
    )

  $scope.cancelCropModal = ->
    $scope.coverPhoto = ''
    $scope.croppedCoverPhoto = ''
    $('#coverPhoto').attr('src', '')
    $('.crop-image-modal').modal 'hide'
    return

  $scope.submitCropModal = ->
    $('.crop-image-modal').modal 'hide'
    return

  $scope.submit = (eventInfo) ->
    $scope.isSubmitting = true

    coverData = {
      coverFile: $scope.croppedCoverPhotoBlob
      url: $scope.preDataCover.url
      fields: $scope.preDataCover.fields
    }
    groupEventService.createEvent(eventInfo ,coverData )
      .then (resp) ->
        if resp.data == 'success'
          flash.success resp.data
          $scope.isSubmitting = false
          $scope.gotoRankTab()
      , (data) ->
        if data?.data.code is 'error.name_already_taken'
          flash.error $filter('translate')('NAME_DUPLICATED')
        else
          flash.error $filter('translate')('API_ERROR')
        $scope.isSubmitting = false

  $scope.buttonCancelClick = ->
    $scope.gotoRankTab()

  $scope.gotoRankTab = ->
    url = "/groups/"+ groupInfo.id + "#rank"
    $location.url(url)

  #valid date start end date
  checkValidDate = ->
    startData = $('#txtStartDate').data('daterangepicker')
    endData   = $('#txtEndDate').data('daterangepicker')
    if startData is undefined || endData is undefined
      return
    $scope.eventInfo.start_date = startData.startDate.format("'YYYY-MM-DD'T'HH:mm:ssZ'")
    $scope.eventInfo.end_date = endData.startDate.endOf("day").format("'YYYY-MM-DD'T'HH:mm:ssZ'")
    if startData.startDate > endData.startDate
      $scope.eventForm.endDate.$setValidity 'dateValid', false
    else
      $scope.eventForm.endDate.$setValidity 'dateValid', true

  isNotValidSizeFile = (file) ->
    file.size > maxFileUploadSize

  openFileDialog = (callback) ->
    options = {
      accept : 'image/*'
    }
    formDialogService._open(options , (file,fileLocation) ->
      if isNotValidSizeFile(file)
        $ngConfirm('Image size is more than ' + maxFileUploadSize + ' bytes')
        return
      callback(file,fileLocation)
    )

GroupEventRegistCtrl.$inject = [
  '$scope'
  '$filter'
  '$location'
  'flash'
  'formDialogService'
  'formFileReaderService'
  'groupInfo'
  'groupRegisDataService'
  'groupEventService'
  '$ngConfirm'
]

module.exports = GroupEventRegistCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/group-event-regist-controller.coffee